export const usernameRegex = /^[a-z]{3}([a-z0-9]{3,})$/

export const fullNameRegex = /^[\w]+[\s]+[\w]+.*$/

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_\s]).{8,}$/

export const cnpjRegex = /(^[\d]{2}\.[\d]{3}\.[\d]{3}\/[\d]{4}-\d{2}$)|(^\d{14}$)/
